import { apiClient } from './apiClient';
import { Category, CreateCategoryRequest } from './types';

export const categoryService = {
  async getAll(): Promise<Category[]> {
    return apiClient.get<Category[]>('/categories');
  },

  async getById(id: string): Promise<Category> {
    return apiClient.get<Category>(`/categories/${id}`);
  },

  async create(category: CreateCategoryRequest): Promise<Category> {
    return apiClient.post<CreateCategoryRequest, Category>('/categories', category);
  },

  async update(id: string, category: CreateCategoryRequest): Promise<Category> {
    return apiClient.put<CreateCategoryRequest, Category>(`/categories/${id}`, category);
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/categories/${id}`);
  },

  async cleanupArchivedTransactions(id: string): Promise<void> {
    await apiClient.post(`/categories/${id}/cleanup-archived`, {});
  }
};
